import axios from "axios";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import ReactPlayer from "react-player";
import { useHistory, useParams } from "react-router-dom";
import { serverInfo } from "../../../App";
import clock from "../../../assets/Icon/clockevent.png";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const DetailsPromoVideo = () => {
  const { videoCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState({});

  const promoDetails = (id) => {
    axios.get(`/api/admin/promoVideo/${id}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data.promoVideo);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    promoDetails(id);
  }, [id]);

  const edit = (id) => {
    history.push(`/superstar-admin/promoVideo/edit/${id}`);
  };

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <div className="card card-bg head-line  mb-2">
            <div className="text-light d-flex justify-content-center p-2">
              <div className="faTrophy">
                <i className="fas fa-trophy"></i>
              </div>
              <h4 className="mx-3 text-white p-2">Promo Video Details</h4>
            </div>
          </div>

          <div className="mt-3 row">
            <div className="col-md-3 p-3">
              <div className="card bg-dark">
                <center>
                  <ReactPlayer
                    url={videoCdnUrl + event.video_url ? videoCdnUrl + event.video_url : null}
                    autoplay
                    controls="true"
                    width={200}
                  />
                </center>
                <div className="">
                  <p className="text-secondary head-line p-2 text-warning mt-2">
                    {event.title}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-9 p-3">
              <div className=" mt-4">
                <div className="row card-bg">
                  <div className="col-md-4 d-flex justify-content-center align-items-center">
                    <img src={clock} className="img-fluid p-3" alt="" />
                  </div>
                  <div className="col-md-4 d-flex align-items-center">
                    <div>
                      <h2 className="text-warning">Promo Video Details</h2>
                      <p className="text-light">
                        &nbsp;
                        {Number(event.status) < 1 ? (
                          <span className="fw-bold">Waiting for Super Star </span>
                        ) : Number(event.status) < 2 ? (
                          <span className="fw-bold">Waiting for Manager Admin</span>
                        ) :('')}
                        &nbsp; Approval
                        {Number(event.status) < 1 ? (
                          <>
                            <button
                              className="btn btnEdit fw-bold w-25 my-2"
                              onClick={() => edit(event.id)}
                            >
                              Edit
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                      </p>
                    </div>
                  </div>

                  <div
                    className="col-md-4"
                    style={{ borderLeft: "1px dashed yellow" }}
                  >
                    <h5 className="text-light text-center my-3">Status</h5>
                    <div className="d-flex justify-content-center align-items-center pb-3">
                      <div style={{ width: 150, height: 150 }}>
                        {Number(event.status) == 1 ? (
                          <CircularProgressbarWithChildren
                            value={50}
                            styles={buildStyles({ pathColor: `gold` })}
                          >
                            {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                            <div style={{ fontSize: 12, marginTop: -5 }}>
                              <strong className="text-light">
                                50% complete
                              </strong>
                            </div>
                          </CircularProgressbarWithChildren>
                        ) :Number(event.status) == 2 ? (
                          <CircularProgressbarWithChildren
                            value={100}
                            styles={buildStyles({ pathColor: `gold` })}
                          >
                            {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                            <div style={{ fontSize: 12, marginTop: -5 }}>
                              <strong className="text-light">
                                100% complete
                              </strong>
                            </div>
                          </CircularProgressbarWithChildren>
                        ) : (
                          <CircularProgressbarWithChildren
                            value={0}
                            styles={buildStyles({ pathColor: `gold` })}
                          >
                            {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                            <div style={{ fontSize: 12, marginTop: -5 }}>
                              <strong className="text-light">
                                0% complete
                              </strong>
                            </div>
                          </CircularProgressbarWithChildren>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DetailsPromoVideo;
